import { WorkflowNodeTypes } from './../../model/workflow-node-types.model';
import { Workflows } from './../../model/workflows.model';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { WorkflowsService } from '../../service/workflows.service';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { Observable, forkJoin, map, throwError, catchError, of } from 'rxjs';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';

@Component({
    selector: 'edit-workflow-information',
    templateUrl: './edit-workflow-information.component.html',
    styleUrls: ['./edit-workflow-information.component.scss']
})
export class EditWorkflowInformationComponent implements OnInit {
    @Input() workflow!: Workflows;

    form!: UntypedFormGroup;
    workflowNodeTypes: WorkflowNodeTypes[];

    isLoading: boolean = false;
    isUpdating: boolean = false;
    msg: MsgModel = {};

    hasPermission: boolean = false;
    permissionIDs: string[] = ['anthony.nguyen', 'lthiru', 'rdiaz2'];

    constructor(private fb: UntypedFormBuilder, private userProfileService: UserProfileService, private workflowsService: WorkflowsService) {
        this.form = fb.group({
            name: ['', [Validators.required]],
            description: ['', Validators.required],
            workflowNodeType: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {
        this.isLoading = true;

        let obs: Observable<any>[] = [];
        obs.push(this.getWorkflowNodeTypes());
        obs.push(this.getPermission());

        forkJoin(obs).subscribe((res) => {
            this.setForm(this.workflow);
            this.getWorkflow();
            this.isLoading = false;
        });
    }

    getPermission() {
        return this.userProfileService.getMyProfile().pipe(
            map((res: any) => {
                if (res.user) {
                    this.hasPermission = this.permissionIDs.findIndex((id: any) => id === res.user.USER_ID) >= 0;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving User Profile.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    getWorkflowNodeTypes() {
        return this.workflowsService.getWorkflowNodeTypes().pipe(
            map((res) => {
                if (res.workflowNodeTypes) {
                    this.workflowNodeTypes = res.workflowNodeTypes;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Workflow Node Types.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    getWorkflow() {
        let workflow: Workflows = new Workflows();

        workflow = JSON.parse(JSON.stringify(this.workflow));
        workflow.NAME = this.form.get('name')?.value;
        workflow.DESCRIPTION = this.form.get('description')?.value;
        workflow.WORKFLOW_NODE_TYPES = this.form.get('workflowNodeType')?.value;
        workflow.WORKFLOW_NODE_TYPES_ID = this.form.get('workflowNodeType')?.value.ID;

        return workflow;
    }

    setForm(workflow: Workflows) {
        this.form.patchValue({
            name: workflow.NAME,
            description: workflow.DESCRIPTION,
            workflowNodeType: this.workflowNodeTypes.find((wfnt) => wfnt.ID === workflow.WORKFLOW_NODE_TYPES?.ID)
        });

        if (!this.hasPermission) {
            this.form.disable();
        }
    }

    generatePayload() {
        let payload: any = {};

        payload.editWorkflow = this.getWorkflow();

        return payload;
    }

    updateWorkflow() {
        this.isUpdating = true;
        this.workflowsService.update(this.generatePayload()).subscribe({
            next: (res) => {
                this.msg = res.msg;
            },
            error: (err) => {
                this.msg = { SUCCESS: false, MSG: 'Error updating workflow.' };
                this.isUpdating = false;
            },
            complete: () => {
                this.isUpdating = false;
            }
        });
    }
}
